// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__tableWrapper--q_zkn {
  height: calc(100% - 12rem);
}
.style__searchBox--RlRgU {
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ModuleConfigOverview/style.less"],"names":[],"mappings":"AAEA;EAEI,0BAAA;AAFJ;AAAA;EAMI,YAAA;AAHJ","sourcesContent":["@import '@yaak/components/src/spacing';\n\n:local {\n  .tableWrapper {\n    height: calc(100% - 12rem);\n  }\n\n  .searchBox {\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `style__tableWrapper--q_zkn`,
	"searchBox": `style__searchBox--RlRgU`
};
export default ___CSS_LOADER_EXPORT___;
